import { Box, Container, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import Seo from '../components/coreLayout/Seo';
import HeroSection from '../components/features/HeroSection';
import HomeBookingCTA from '../components/features/HomeBookingCTA';
import IconSection from '../components/features/IconSection';
import InstagramImages from '../components/features/InstagramImages';
import ProductDisplayGrid from '../components/features/ProductDisplayGrid';
import SocialProof from '../components/features/SocialProof';
import { ProductCategories } from '../utils/models/products';
import { baseProducts } from '../utils/stores/productCodes';

const homeSx = {
    accent: {
        width: 56,
        height: 4,
        borderRadius: '4px',
        backgroundColor: 'primary.main',
        margin: '18px 0 20px',
    },
    backgroundContrast: (theme: Theme) => ({
        background: ` -webkit-linear-gradient(rgba(255, 255, 255, 1), ${theme.palette.background.subtle})`,
        width: '100%',
    }),
} as const;

const eyebrowSx = {
    color: 'primary.main',
    letterSpacing: '0.18em',
    fontWeight: 700,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    mb: 1.25,
} as const;

const titleSx = {
    fontSize: { xs: 30, md: 38 },
    color: 'text.primary',
    lineHeight: 1.15,
    letterSpacing: '-1px',
    fontWeight: 700,
    m: 0,
} as const;

const bodySx = {
    fontSize: { xs: 16, md: 18 },
    color: 'text.soft',
    fontWeight: 400,
    maxWidth: 620,
    lineHeight: 1.6,
} as const;

const HomePage = () => {
    const heroTiles = baseProducts
        .map((prod) => prod.tags.includes('featureTile') && prod.productCode)
        .filter((res) => res);

    return (
        <>
            <Seo
                title="Cairns Scenic Flights & Great Barrier Reef Tours | GSL Aviation"
                description="GSL Aviation runs daily scenic flights from Cairns over the Great Barrier Reef and Green Island. Book Cairns reef flights and tours online with instant confirmation."
                path="/"
            />
            <HeroSection productCodes={heroTiles} />
            <HomeBookingCTA />
            <Box sx={homeSx.backgroundContrast}>
                <Container
                    maxWidth="md"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        py: { xs: 6, md: 9 },
                    }}
                >
                    <Typography component="p" sx={eyebrowSx}>
                        Far North Queensland
                    </Typography>
                    <Typography component="h2" sx={titleSx}>
                        Tours in Cairns
                    </Typography>
                    <Box sx={homeSx.accent} />
                    <Typography sx={bodySx}>
                        Departing from Cairns International Airport, our scenic flights enjoy sweeping views of the city
                        and North Qld coastline — just a short hop to a birds-eye view of the Great Barrier Reef, one of
                        the natural wonders of the world. Explore our flights and packages, from the Reef to the
                        Rainforest.
                    </Typography>
                </Container>
            </Box>
            <ProductDisplayGrid backgroundColor category={ProductCategories.CAIRNS} tag={'popular'} />
            <SocialProof />
            <IconSection />
            <InstagramImages />
        </>
    );
};

export default HomePage;
